/**
 * @author Martin Leonov <martin.leonov@ki-wi.cz>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

import BaseViewerManagerController, {
  getContentTasks
} from './base-viewer-manager-controller';

/**
 * @import { ViewerManagerController } from '.'
 */

/**
 * @implements {ViewerManagerController}
 */
export default class BasicController extends BaseViewerManagerController {
  /** @type {ViewerManagerController['start']} */
  async start() {
    await super.preload(
      getContentTasks(this.contentInfo.contentTasks, this.display1InitTarget)
    );
    await super.start();
  }

  /** @type {ViewerManagerController['stop']} */
  async stop() {
    await super.stop();
  }
}
